module.exports = __webpack_public_path__ + "static/media/password-cream.259362a2.svg";